"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useComponents: true,
  ComponentProvider: true,
  HeaderComponent: true,
  FormSection: true,
  InputContainer: true,
  List: true,
  ListItemRemovable: true,
  ListItemAction: true,
  NavMenu: true,
  NavMenuItem: true,
  NavMenuSeparator: true,
  NavItem: true,
  Table: true,
  GridTable: true,
  SideNav: true,
  TopNav: true,
  Layouts: true,
  Loading: true,
  ScalableLoading: true,
  Scrollspy: true,
  TopUserMenu: true,
  TopUserMenuControl: true,
  SideUserMenu: true,
  SideUserMenuControl: true,
  UserMenuItem: true,
  UserMenuSeparator: true,
  UserMenuItems: true,
  AvlModal: true
};
Object.defineProperty(exports, "HeaderComponent", {
  enumerable: true,
  get: function get() {
    return _HeaderComponent["default"];
  }
});
Object.defineProperty(exports, "FormSection", {
  enumerable: true,
  get: function get() {
    return _FormSection.FormSection;
  }
});
Object.defineProperty(exports, "InputContainer", {
  enumerable: true,
  get: function get() {
    return _FormSection.InputContainer;
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List.List;
  }
});
Object.defineProperty(exports, "ListItemRemovable", {
  enumerable: true,
  get: function get() {
    return _List.ListItemRemovable;
  }
});
Object.defineProperty(exports, "ListItemAction", {
  enumerable: true,
  get: function get() {
    return _List.ListItemAction;
  }
});
Object.defineProperty(exports, "NavMenu", {
  enumerable: true,
  get: function get() {
    return _Menu.NavMenu;
  }
});
Object.defineProperty(exports, "NavMenuItem", {
  enumerable: true,
  get: function get() {
    return _Menu.NavMenuItem;
  }
});
Object.defineProperty(exports, "NavMenuSeparator", {
  enumerable: true,
  get: function get() {
    return _Menu.NavMenuSeparator;
  }
});
Object.defineProperty(exports, "NavItem", {
  enumerable: true,
  get: function get() {
    return _Item["default"];
  }
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return _Table["default"];
  }
});
Object.defineProperty(exports, "GridTable", {
  enumerable: true,
  get: function get() {
    return _gridTable["default"];
  }
});
Object.defineProperty(exports, "SideNav", {
  enumerable: true,
  get: function get() {
    return _Side["default"];
  }
});
Object.defineProperty(exports, "TopNav", {
  enumerable: true,
  get: function get() {
    return _Top["default"];
  }
});
Object.defineProperty(exports, "Layouts", {
  enumerable: true,
  get: function get() {
    return _Layouts["default"];
  }
});
Object.defineProperty(exports, "Loading", {
  enumerable: true,
  get: function get() {
    return _Loading["default"];
  }
});
Object.defineProperty(exports, "ScalableLoading", {
  enumerable: true,
  get: function get() {
    return _Loading.ScalableLoading;
  }
});
Object.defineProperty(exports, "Scrollspy", {
  enumerable: true,
  get: function get() {
    return _scrollspy["default"];
  }
});
Object.defineProperty(exports, "TopUserMenu", {
  enumerable: true,
  get: function get() {
    return _UserMenu.TopUserMenu;
  }
});
Object.defineProperty(exports, "TopUserMenuControl", {
  enumerable: true,
  get: function get() {
    return _UserMenu.TopUserMenuControl;
  }
});
Object.defineProperty(exports, "SideUserMenu", {
  enumerable: true,
  get: function get() {
    return _UserMenu.SideUserMenu;
  }
});
Object.defineProperty(exports, "SideUserMenuControl", {
  enumerable: true,
  get: function get() {
    return _UserMenu.SideUserMenuControl;
  }
});
Object.defineProperty(exports, "UserMenuItem", {
  enumerable: true,
  get: function get() {
    return _UserMenu.UserMenuItem;
  }
});
Object.defineProperty(exports, "UserMenuSeparator", {
  enumerable: true,
  get: function get() {
    return _UserMenu.UserMenuSeparator;
  }
});
Object.defineProperty(exports, "UserMenuItems", {
  enumerable: true,
  get: function get() {
    return _UserMenu.UserMenuItems;
  }
});
Object.defineProperty(exports, "AvlModal", {
  enumerable: true,
  get: function get() {
    return _avlModal["default"];
  }
});
exports.ComponentProvider = exports.useComponents = void 0;

var _react = _interopRequireDefault(require("react"));

var _HeaderComponent = _interopRequireDefault(require("./Header/HeaderComponent"));

var _FormSection = require("./Forms/FormSection");

var _List = require("./List/List");

var _Menu = require("./Nav/Menu");

var _Item = _interopRequireDefault(require("./Nav/Item"));

var _Table = _interopRequireDefault(require("./Table"));

var _gridTable = _interopRequireDefault(require("./Table/grid-table"));

var _Side = _interopRequireDefault(require("./Nav/Side"));

var _Top = _interopRequireDefault(require("./Nav/Top"));

var _Layouts = _interopRequireDefault(require("./Layouts"));

var _Loading = _interopRequireWildcard(require("./Loading"));

var _scrollspy = _interopRequireDefault(require("./Sidebar/scrollSpy/scrollspy"));

var _UserMenu = require("./Header/UserMenu");

var _Containers = require("./Containers");

Object.keys(_Containers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Containers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Containers[key];
    }
  });
});

var _Inputs = require("./Inputs");

Object.keys(_Inputs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Inputs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Inputs[key];
    }
  });
});

var _Button = require("./Button");

Object.keys(_Button).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Button[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Button[key];
    }
  });
});

var _utils = require("./utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

var _DndList = require("./List/DndList");

Object.keys(_DndList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DndList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DndList[key];
    }
  });
});

var _collapsibleSidebar = require("./Sidebar/collapsible-sidebar");

Object.keys(_collapsibleSidebar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _collapsibleSidebar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _collapsibleSidebar[key];
    }
  });
});

var _legend = require("./Legend/legend");

Object.keys(_legend).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _legend[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _legend[key];
    }
  });
});

var _draggable = require("./Draggable/draggable");

Object.keys(_draggable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _draggable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _draggable[key];
    }
  });
});

var _avlModal = _interopRequireDefault(require("./Modal/avl-modal"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ComponentContextDefaults = {
  TopUserMenu: _UserMenu.TopUserMenu,
  TopUserMenuControl: _UserMenu.TopUserMenuControl,
  SideUserMenu: _UserMenu.SideUserMenu,
  SideUserMenuControl: _UserMenu.SideUserMenuControl,
  UserMenuItem: _UserMenu.UserMenuItem,
  UserMenuSeparator: _UserMenu.UserMenuSeparator,
  UserMenuItems: _UserMenu.UserMenuItems
};

var ComponentContext = /*#__PURE__*/_react["default"].createContext(ComponentContextDefaults);

var useComponents = function useComponents() {
  return _react["default"].useContext(ComponentContext);
};

exports.useComponents = useComponents;

var ComponentProvider = function ComponentProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(ComponentContext.Provider, {
    value: _objectSpread(_objectSpread({}, ComponentContextDefaults), props)
  }, children);
};

exports.ComponentProvider = ComponentProvider;